
import { Vue, Component, Prop } from 'vue-property-decorator';
import { RuleConditionItem, RuleConditionDefinition } from '@/types';
import RuleConditionList from './RuleConditionList.vue';

@Component({ components: { RuleConditionList } })
export default class RuleConditionBuilder extends Vue {
  @Prop({ type: Array, required: true }) readonly value!: RuleConditionItem[];
  @Prop({ type: Array, required: true }) readonly conditionDefinitions!: RuleConditionDefinition[];
  @Prop({ type: Array, default: () => [] }) readonly users!: any[];
  @Prop({ type: Array, default: () => [] }) readonly groups!: any[];
  @Prop({ type: Array, default: () => [] }) readonly categories!: any[];
  @Prop({ type: Array, default: () => [] }) readonly tags!: any[];
  @Prop({ type: Array, default: () => [] }) readonly templates!: any[];
  @Prop({ type: Array, default: () => [] }) readonly checklists!: any[];
}
